/* =====================================================
   assets/five-min-new-face-2026.js
   NuFace 2026 Redesign — 5-min-new-face carousel controller
   MS 2026-06-01 PM

   Native scroll-snap track. Prev/next buttons, keyboard nav
   (ArrowLeft / ArrowRight / Home / End when section focused),
   per-slide aria-label "N of M" computed against currently
   visible slides (callout counts on mobile, not desktop —
   the callout is display:none >=1024). aria-disabled toggled
   on prev/next based on scrollLeft position.

   Pattern mirrors real-results-testimonials-2026.js for
   ARIA + init/section-reload hooks; scroll mechanism is
   native scroll-snap with scrollBy(stepPx), not transform.
   ===================================================== */

(function () {
  'use strict';

  function getVisibleSlides(section) {
    var nodes = section.querySelectorAll('[data-fm-slide]');
    var visible = [];
    for (var i = 0; i < nodes.length; i++) {
      // offsetParent is null when element or an ancestor is display:none.
      // This is how we exclude the callout on desktop without duplicating
      // the breakpoint logic in JS.
      if (nodes[i].offsetParent !== null) visible.push(nodes[i]);
    }
    return visible;
  }

  function initSection(section) {
    if (section.dataset.fmInited === '1') return;
    section.dataset.fmInited = '1';

    var track   = section.querySelector('[data-fm-track]');
    var prevBtn = section.querySelector('[data-fm-prev]');
    var nextBtn = section.querySelector('[data-fm-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateSlideAria() {
      var slides = getVisibleSlides(section);
      var total = slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].setAttribute('aria-label', (i + 1) + ' of ' + total);
      }
    }

    function getStep() {
      var slides = getVisibleSlides(section);
      if (slides.length < 2) return 0;
      // Distance between first two visible slides = card width + gap.
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function scrollByStep(delta) {
      var step = getStep();
      if (step === 0) return;
      track.scrollBy({ left: delta * step, behavior: 'smooth' });
    }

    function scrollToEdge(end) {
      if (end === 'start') {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      }
    }

    function updateArrowState() {
      var atStart = track.scrollLeft <= 2;
      var atEnd   = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd   ? 'true' : 'false');
    }

    prevBtn.addEventListener('click', function () {
      if (prevBtn.getAttribute('aria-disabled') === 'true') return;
      scrollByStep(-1);
    });
    nextBtn.addEventListener('click', function () {
      if (nextBtn.getAttribute('aria-disabled') === 'true') return;
      scrollByStep(1);
    });

    section.addEventListener('keydown', function (e) {
      var key = e.key;
      if (key === 'ArrowLeft')        { scrollByStep(-1);    e.preventDefault(); }
      else if (key === 'ArrowRight')  { scrollByStep(1);     e.preventDefault(); }
      else if (key === 'Home')        { scrollToEdge('start'); e.preventDefault(); }
      else if (key === 'End')         { scrollToEdge('end');   e.preventDefault(); }
    });

    // Debounced scroll listener to keep aria-disabled in sync with native scroll/swipe.
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateArrowState, 80);
    });

    updateSlideAria();
    updateArrowState();

    // ResizeObserver recomputes slide-count + arrow state on breakpoint changes
    // (most importantly when the callout flips between display:flex <=1023 and
    // display:none >=1024, which changes the visible-slide count).
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        updateSlideAria();
        updateArrowState();
      });
      ro.observe(section);
    } else {
      window.addEventListener('resize', function () {
        updateSlideAria();
        updateArrowState();
      });
    }
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.five-min-new-face-2026[data-section-id]');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when a section is reloaded in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
